import { create } from 'zustand';

type ToastType = 'success' | 'error';

type ToastState = {
  type: ToastType;
  message: string;
  isVisible: boolean;
  bottom: string;
  showToast: (type: ToastType, message: string, bottom: string) => void;
  hideToast: () => void;
};

export const useToastStore = create<ToastState>((set) => ({
  type: 'success',
  message: '',
  isVisible: false,
  bottom: '5rem',
  showToast: (type, message, bottom) => set({ type, message, isVisible: true, bottom }),
  hideToast: () => set({ isVisible: false, message: '', bottom: '5rem' }),
}));
